import React from 'react';
import { NavigationControl, Source, Layer } from 'react-map-gl';
import { useMapContext } from '../Map/MapContext';

// const MapControlPanel = ({ subcatchments, outfalls, selectedFeatureID, overflowData, stormMode, getColorLayer, getOutfallColor }) => {

const MapControlPanel = ({getColorLayer, getOutfallColor}) => {
    const {
        geoJSONData,
        selectedFeature,
        stormMode,
        LIDMode,
        // LIDContent,
        // devPlanContent,
    } = useMapContext();

    const subcatchments = geoJSONData.subcatchments;
    const outfalls = geoJSONData.outfalls;
    const overflowData = geoJSONData.overflowData;
    const selectedFeatureID = selectedFeature.ID;

    return (
        <>
        <NavigationControl 
            visualizePitch={true} 
            position="bottom-left" 
        />

        {subcatchments && (
            <Source id="subcatchments-layer" type="geojson" data={subcatchments}>
            <Layer {...getColorLayer()} />
            </Source>
        )}

        {outfalls && (
            <Source id="outfalls-layer" type="geojson" data={outfalls}>
            <Layer
                id="outfalls"
                type="circle"
                paint={{
                'circle-radius': 5,
                'circle-opacity': 1,
                'circle-color': [
                    'case',
                    ['==', ['get', 'NAME'], selectedFeatureID], 
                    '#ffa600', // Highlight color for the selected outfall
                    overflowData ? [
                    'match',
                    ['get', 'NAME'],
                    ...Object.keys(overflowData).flatMap(key => [key, getOutfallColor(overflowData[key], stormMode, overflowData, LIDMode)]),
                    '#bcad8f'  // Fallback color for unmatched outfalls
                    ] : '#bcad8f'  // Default color if overflowData is null
                ],
                }}
            />
            </Source>
        )}
        </>
    );
};

export default MapControlPanel;
